import { useCallback } from 'react';

import { useDocumentStore } from '@/store';

type FocusableElement =
  | HTMLButtonElement
  | HTMLInputElement
  | HTMLSelectElement
  | HTMLTextAreaElement
  | HTMLAnchorElement
  | HTMLElement;

export const useFocusNext = () => {
  const focusedField = useDocumentStore((state) => state.focusedField);

  const focusNext = useCallback(() => {
    const selectors = ['input', 'textarea', '[tabindex]:not([tabindex="-1"])'].join(',');

    const elements = Array.from(document.querySelectorAll<FocusableElement>(selectors)).filter((el) => {
      if ('disabled' in el && el.disabled) return false;
      return el.offsetParent !== null;
    });

    const currentIndex = elements.findIndex((el) => el.id === focusedField?.id);
    const nextIndex = (currentIndex + 1) % elements.length;
    elements[nextIndex].focus();
  }, [focusedField?.id]);

  return focusNext;
};
